import { Component, OnInit } from "@angular/core";
import { AzureSearchService } from "../../../../lib/azure-search/azure-search";
import { AuthenticationService } from "../../../../lib/core/core";
import { Account } from "../../account";

@Component({
  selector: "common-account-verification-banner",
  templateUrl: "./account-verification-banner.component.html",
})
export class AccountVerificationBannerComponent implements OnInit {
  verificationBanner: string;
  bannerMessages: string[] = [];
  toolTipText: string = "";

  constructor(private azureSearchService: AzureSearchService, private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    const user = this.authenticationService.getUserNonAsync();
    this.azureSearchService.getOne(user.profile.account_id, "accounts").subscribe((account: Account) => {
      switch (account?.verificationStatus) {
        case "Unverified":
          this.verificationBanner = "Unverified";
          this.bannerMessages.push("<span class='font-weight-bold m-0'>Your account has not been verified yet.</span>");
          this.toolTipText =
            "To rent through Rubbl, we require a credit check and insurance verification. <a href='/help/rental-terms#payments'>See details</a>";
          break;

        case "Denied":
          this.verificationBanner = "Denied";
          this.bannerMessages.push("<span class='font-weight-bold'>Your account has been denied. Please contact (866)-455-8531</span>");

          break;
      }
    });
  }
}
